
export const Loops = ['loop_external', 'loop_usual_components', 'loop_trading']
// export const Loops = ['loop_external', 'loop_internal']
   


// WEBPACK FOOTER //
// ./src/core/services/loops.js